import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { message, Tooltip } from "antd";

function copyContent(content, lifecycleCbs) {
  navigator.clipboard
    .writeText(content)
    .then(lifecycleCbs.success)
    .catch(lifecycleCbs.error);
}

export default function AssistantId(props) {
  const { assistantId } = props;

  const handleCopyClick = () => {
    const lifecycleCbs = {
      success: () => {
        message.success("ID Copied");
      },
      error: (err) => {
        message.error("Failed to Copy ID");
      },
    };

    copyContent(assistantId, lifecycleCbs);
  };

  return (
    <>
      <Tooltip title="Copy ID">
        <div
          className="flex gap-x-1 items-start hover:cursor-pointer"
          onClick={handleCopyClick}
        >
          <p className="text-sm text-gray-500">ID: &nbsp;{assistantId}</p>
          <DocumentDuplicateIcon className="size-4 text-gray-500 hover:text-gray-700" />
        </div>
      </Tooltip>
    </>
  );
}
